import Button from '../button';
const PickerButton = (props, { attrs, slots }) => {
    return <Button size="small" type="primary" {...props} {...attrs} v-slots={slots}></Button>;
};
export default PickerButton;
